import { Controller } from "@hotwired/stimulus";

// GO4TEACH (2026-10-27): the address typed, suggested from OpenStreetMap (`/places`, asked from
// the server). Picking a suggestion fills the fields it knows — `data-g4t-address-field="city"`
// and the like —; every field stays editable by hand, and nothing is sent before « Enregistrer ».
export default class extends Controller {
  static targets = ["query", "results"];
  static values = { url: String, kind: { type: String, default: "address" } };

  connect() {
    this.places = [];
  }

  search() {
    clearTimeout(this.timer);
    const query = this.queryTarget.value.trim();
    if (query.length < 3) return this.close();
    this.timer = setTimeout(() => this.fetch(query), 300);
  }

  async fetch(query) {
    const url = `${this.urlValue}?kind=${this.kindValue}&q=${encodeURIComponent(query)}`;
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" } });
      if (!response.ok) return this.close();
      this.places = (await response.json()).data || [];
      this.render();
    } catch {
      this.close();
    }
  }

  render() {
    if (this.places.length === 0) return this.close();
    this.resultsTarget.innerHTML = "";
    this.places.forEach((place, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "ds-option";
      button.textContent = place.label;
      button.dataset.index = index;
      button.dataset.action = "g4t-address#pick";
      this.resultsTarget.appendChild(button);
    });
    this.resultsTarget.hidden = false;
  }

  pick(event) {
    const place = this.places[Number(event.currentTarget.dataset.index)];
    if (!place) return;
    const values = {
      complete_address: place.label, street_address: place.street, quarter: place.quarter, city: place.city,
      region: place.region, country: place.country, country_code: place.country_code,
      latitude: place.latitude, longitude: place.longitude,
    };
    this.element.querySelectorAll("[data-g4t-address-field]").forEach((field) => {
      const value = values[field.dataset.g4tAddressField];
      if (value !== undefined && value !== null) field.value = value;
    });
    this.close();
  }

  close() {
    this.resultsTarget.hidden = true;
    this.resultsTarget.innerHTML = "";
  }
}
